module.exports = __webpack_public_path__ + "img/drivers-indoor-linear.3e7c420f.jpg";